import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import BrandLogo from "./brand/Logo";
import { Button } from "./ui/button";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/platform", label: "Solutions" },
  { to: "/auditiq-sports", label: "Sports IQ" },
  { to: "/certifications", label: "Certifications" },
  { to: "/about", label: "Transparency Institute" },
  { to: "/crown-institute-academy", label: "Crown Institute Academy" },
  { to: "/curriculum", label: "Course Catalog" },
  { to: "/sponsors", label: "Sponsors" },
  { to: "/donate", label: "Donate" },
  { to: "/store", label: "Store" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-50 bg-navy-deep/90 backdrop-blur border-b border-gold-dim/30" data-testid="site-navbar">
      <div className="container-wide py-3 sm:py-4 flex items-center justify-between gap-3">
        <Link to="/" data-testid="brand-home-link" className="shrink-0">
          <BrandLogo withWord={false} />
        </Link>
        <nav className="hidden 2xl:flex items-center gap-0.5 flex-1 justify-center min-w-0">
          {NAV.map(n => (
            <NavLink
              key={n.to} to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-2 py-2 text-sm tracking-wide transition-colors whitespace-nowrap font-medium ${
                  isActive ? "text-gold" : "text-cream-dim hover:text-gold"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden 2xl:flex items-center gap-2 shrink-0">
          <Button
            variant="ghost"
            onClick={() => nav("/portal/login")}
            className="btn-ghost-gold h-10"
            data-testid="nav-portal-login"
          >
            Login
          </Button>
          <Button
            onClick={() => nav("/contact")}
            className="btn-gold h-10"
            data-testid="nav-request-demo"
          >
            Request Demo
          </Button>
        </div>
        <button
          className="2xl:hidden text-gold p-1" onClick={() => setOpen(v => !v)}
          aria-label="Toggle menu" data-testid="mobile-menu-btn"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="2xl:hidden border-t border-gold-dim/30 px-4 sm:px-6 py-4 bg-navy-deep max-h-[80vh] overflow-y-auto" data-testid="mobile-menu">
          <div className="flex flex-col gap-1">
            {NAV.concat([{ to: "/demo", label: "Demo Mode" }, { to: "/contact", label: "Contact" }]).map(n => (
              <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 text-base tracking-wide border-b border-gold-dim/10 ${isActive ? "text-gold" : "text-cream-dim"}`
                }>
                {n.label}
              </NavLink>
            ))}
            <div className="flex gap-2 pt-3 mt-2 btn-stack">
              <Button onClick={() => { nav("/portal/login"); setOpen(false); }}
                className="btn-ghost-gold h-10" data-testid="mobile-login-btn">
                Login
              </Button>
              <Button onClick={() => { nav("/contact"); setOpen(false); }}
                className="btn-gold h-10" data-testid="mobile-request-demo-btn">
                Request Demo
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
